import React from 'react';
import AppBar from '../../commons/AppBar'
import SpecificComponent from '../../commons/SpecificComponent';
import Commons from '../../commons/Commons';
import FromServer from './FromServer';
import { Grid, TextField, Button, Switch, Divider, FormControl, InputLabel, Select, Input, MenuItem } from '@material-ui/core';
import AlertDialog from '../../commons/dialogs/AlertDialog'
import Ws from '../../providers/Ws';

import avatar from '../../Pics/avatar.jpg'
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import GanttEtapeMonthView from '../../commons/GanttEtapeMonthView';
import GanttProiecteMonthView from '../../commons/GanttProiecteMonthView';
import TaskuriList from '../../commons/TaskuriList';


export default class InfoUser extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            objUserData: {},
            isOpenAlert: false,
            userAdmin: new LocalStorage().GetUserData().InfoUser.IsAdmin ? false : true,
            proiecte: [],
            isOpenInsert: false,
            strNumeProiect: this.dictionary.proiecte.numeProiect,
            dtStartDate: new Date(),
            objPerioadaGantt: {},
            listDays: new Utils().getZile(new Date().getMonth() + 1),
            listEtape: [],
            listTaskuri: [],
            listSubTaskuri: [],
            listTaskuriFiltered: [],
            tipuriFilter: ['An', 'Luna', 'Saptamana', 'Zi'],
            tipFilter: 'An',
            displayAn: true,
            displayLuna: false,
            displayZi: false,
            displaySapt: false,
            luna: new Date().getMonth() + 1,
            dataStartWeek:'',
            dataFinishWeek:'',

            nrYear: new Date().getFullYear(),
            listYears: new Utils().getLast10Years(),
            listMonths: new Utils().getMonths,
            day: new Date().getDate(),

        }
    }

    componentDidMount() {
        this.getUser()
        this.getProiecte()
  
    }

    goToPage = (page) => {

        this.props.history.push(`/${page}`)
    }


    dataAzi = () => {
        let u = new Utils()

        let dataAzi = u.defaultData()

        if (this.dictionary.date === 'en') {
            return u.dataPrescurtataEng(dataAzi)
        } else {
            return u.dataPrescurtataRomana(dataAzi)
        }
    }




    getProiecte = async () => {

        let ws = new Ws();

        let u = new Utils();

        let fS = new FromServer();

        let _proiecte = fS.getProiecte(this.props.match.params.iduser)

        let _etape = fS.getEtapeAll()

        let [proiecte, etape, t] = await Promise.all([_proiecte, _etape, fS.getTaskuriAll(this.props.match.params.iduser)])

        // console.log('etape :', etape);

        if (proiecte.Succes) {

            // console.log('t :', t);

            let cloneEtape = [...etape]



            let cloneTaskuri = [...t]

            let counter3 = cloneTaskuri.length

            let counter2 = cloneEtape.length

            let subTaskuri = t.filter(i => i.id_task_parent !== null)

            let tasks = [...t]

            // console.warn('subTaskuri :', subTaskuri);

            for (let i = 0; i < counter3; i++) {

                if (tasks[i].statusul !== 'Finalizat') {

                    let filterSubT = subTaskuri.filter(st => st.id_task_parent === tasks[i].id)

                    if (filterSubT.length > 0) {
                        filterSubT = filterSubT.filter(t => t.statusul !== 'Finalizat')

                        let subTTrecute = filterSubT.filter(t => new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date())
                        let subTInViitor = filterSubT.filter(t => new Date(u.ParseDataFromSql(t.cand_data)) > new Date())

                        // console.warn('subTTrecute :', subTTrecute);
                        // console.warn('subTInViitor :', subTInViitor);
                        if (tasks[i].id === 32) {
                            // console.log('filterSubT :', filterSubT);
                            // console.log('filterSubT :', subTInViitor);
                        }

                        if (filterSubT.length > 0) {
                            if (subTTrecute.length > 0) {
                                if (tasks[i].id === 32) {
                                    // console.log('filterSubT :', subTTrecute);
                                }
                                tasks[i].color = '#ff3f3f'
                            } else if (filterSubT.length === subTInViitor.length) {

                                tasks[i].color = 'rgb(58, 180, 209)'
                            } else {
                                tasks[i].color = 'rgb(251, 141, 0)'
                            }

                        } else {
                            tasks[i].color = 'rgb(251, 141, 0)'
                        }

                    } else {

                        if (new Date(u.ParseDataFromSql(tasks[i].pana_cand_data)) <= new Date()) {
                            // console.log('colorTask :');
                            tasks[i].color = '#ff3f3f'
                        } else if (new Date(u.ParseDataFromSql(tasks[i].cand_data)) > new Date()) {
                            tasks[i].color = 'rgb(58, 180, 209)'
                        } else {
                            tasks[i].color = 'rgb(251, 141, 0)'
                        }
                    }

                } else {
                    tasks[i].color = 'rgb(122, 209, 58)'
                }
            }

            tasks = tasks.filter(t => (t.cand_data !== null) && (t.pana_cand_data !== null))
            tasks = tasks.filter(t => t.statusul !== 'Finalizat').filter(i => i.id_task_parent === null)

            let newTasks = []

            for (let i = 0; i < counter2; i++) {
                let filterTaskuri = cloneTaskuri.filter(t => t.id_etapa_proiect === cloneEtape[i].id)
                let tNew = tasks.filter(t => t.id_etapa_proiect === cloneEtape[i].id)

                // console.log('cloneTaskuri :', filterTaskuri);

               tNew  = tNew.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(cloneEtape[i].durata_pana_la) 
                                                && new Date(u.ParseDataFromSql(t.pana_cand_data)) < new Date(cloneEtape[i].durata_pana_la))).map((t)=>{
                                                    // console.log('t :', t);
                                                    if(t !== undefined){
                                                         newTasks.push(t)
                                                    }
                                                   
                                                })

                filterTaskuri = filterTaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(cloneEtape[i].durata_pana_la) && new Date(u.ParseDataFromSql(t.pana_cand_data)) < new Date(cloneEtape[i].durata_pana_la)))

                filterTaskuri = filterTaskuri.filter(t => t.pana_cand_data !== null)

                filterTaskuri = filterTaskuri.filter(t => t.statusul !== 'Finalizat')

                // console.log('filterTaskuri :', filterTaskuri);

                let taskuriTrecute = filterTaskuri.filter(t => new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date())

                let taskuriInViitor = filterTaskuri.filter(t => new Date(u.ParseDataFromSql(t.cand_data)) > new Date())

                if (filterTaskuri.length > 0) {
                    if (taskuriTrecute.length > 0) {
                        cloneEtape[i].color = '#ff3f3f'
                    } else if (filterTaskuri.length === taskuriInViitor.length) {
                        cloneEtape[i].color = 'rgb(58, 180, 209)'
                    } else {
                        cloneEtape[i].color = 'rgb(251, 141, 0)'
                    }

                } else {
                    cloneEtape[i].color = 'rgb(122, 209, 58)'
                }



                //     cloneEtape[i].color = '#ff3f3f'
                // }else if (filterTaskuri.length > 0){
                //     cloneEtape[i].color = 'rgb(247, 167, 16)'
                // }else{
                //     cloneEtape[i].color = '#7ad13a'
                // }

            }

            // console.warn('newTasks :', newTasks);

            // console.log('cloneEtape :', cloneEtape);


            let cloneProiecte = [...proiecte.Content]

            let counter = cloneProiecte.length

            let perioadaDeLa = u.defaultData()

            let perioadaPanaLa = u.defaultDataPlus3Months();

            for (let i = 0; i < counter; i++) {


                cloneProiecte[i].perioada_dela = u.ParseDataFromSql(cloneProiecte[i].perioada_dela)
                cloneProiecte[i].perioada_panala = u.ParseDataFromSql(cloneProiecte[i].perioada_panala)
            }

            for (let i = 0; i < counter; i++) {
                if (new Date(cloneProiecte[i].perioada_dela) < new Date(perioadaDeLa)) {
                    perioadaDeLa = cloneProiecte[i].perioada_dela
                }

                if (new Date(cloneProiecte[i].perioada_panala) > new Date(perioadaPanaLa)) {
                    perioadaPanaLa = cloneProiecte[i].perioada_panala
                }
            }

            // console.log('perioadaDeLa :', perioadaDeLa);
            // console.log('perioadaPanaLa :', perioadaPanaLa);



            // console.log('Cloneproiecte :', cloneProiecte);

            // console.log('listTaskuriFiltered :', tasks);

           

            this.setState({
                proiecte: cloneProiecte,
                objPerioadaGantt: { dtPerioadaDeLa: perioadaDeLa, dtPerioadaPanaLa: perioadaPanaLa },
                listEtape: cloneEtape,
                listTaskuri: newTasks,
                listTaskuriFiltered: newTasks,
                listSubTaskuri: subTaskuri
            })
        }
    }


    onProiectSelectat = (p) => {

        this.props.history.push(`/useretape/${this.props.match.params.iduser}/${p.id}`)
    }


    handleChange = n => ev => {
        let clone = { ...this.state.objUserData }

        clone[n] = ev.target.value

        this.setState({ objUserData: clone })
    }

    handleChecked = n => async ev => {
        let clone = { ...this.state.objUserData }

        clone[n] = ev.target.checked === true ? 1 : 0

        let objToUpdate = {

        }

        objToUpdate[n] = ev.target.checked === true ? 1 : 0

        // console.log('objToUpdate :', objToUpdate);


        let fs = new FromServer();



        let update = await fs.updateUser(objToUpdate, this.props.match.params.iduser)

        this.setState({ objUserData: clone })
    }


    buildAppBarButtons = () => {

        let buttons = [
            {
                onClick: () => { this.props.history.goBack() },
                text: this.dictionary.appBar.buttons.inapoi,
                icon: 'keyboard_arrow_left'
            },
            // {
            //     onClick: this.testAdauga,
            //     text: this.dictionary.comune.edit,
            //     icon: 'edit'
            // },

        ]

        let C = new Commons()

        return C.generateAppBarButtons(buttons)
    }


    updateUser = async () => {


        let objToUpdate = {
            nume: this.state.objUserData.nume,
            telefon: this.state.objUserData.telefon,
            email: this.state.objUserData.email
        }



        let fs = new FromServer();



        let update = await fs.updateUser(objToUpdate, this.props.match.params.iduser)


    }


    getUser = async () => {
        let fs = new FromServer();


        let user = await fs.getUser(this.props.match.params.iduser)

        // console.log('user :', user);

        this.setState({ objUserData: user[0] })
    }

    selectFile = (id) => {
        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()
    }

    uploadPoza = async (id, idAngajat) => {
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/PozaAngajat', saveFile, idAngajat);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.getUser()
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }
    }


    goToTaskProj = (t) => {
        this.props.history.push(`/useretape/${this.props.match.params.iduser}/${t.id_proiect}`)
    }

    changeFilter = (ev) => {

        if (ev.target.value === 'An') {
            this.setState({
                displayAn: true,
                displayLuna: false,
                displayZi: false,
                displaySapt: false,
                tipFilter: ev.target.value
            })
        } else if (ev.target.value === 'Luna') {
            this.setState({
                displayAn: true,
                displayLuna: true,
                displayZi: false,
                displaySapt: false,
                tipFilter: ev.target.value
            })
        } else if (ev.target.value === 'Zi') {
            this.setState({
                displayAn: true,
                displayLuna: true,
                displayZi: true,
                displaySapt: false,
                tipFilter: ev.target.value
            })
        }
        else  {
            this.setState({
                displayAn: false,
                displayLuna: false,
                displayZi: false,
                displaySapt: true,
                tipFilter: ev.target.value
            },()=>{
                this.getSaptamana()
            })
        }
    }



    getSaptamana = () =>{

        let u = new Utils()
        let dataCurenta = new Date()

        let dataStart = u.addDays(dataCurenta, -1 *( dataCurenta.getDay() - 1 ))

        let dataFinish = u.addDays(dataStart , 6)

        // console.log('dataStart :', dataStart);

        // console.log('dataFinish :', dataFinish);


        let cloneTaskuri = [...this.state.listTaskuri]




        let taskuriFilter = cloneTaskuri.filter(t => (new Date(u.ParseDataFromSql(t.pana_cand_data)) >  dataStart) && (new Date(u.ParseDataFromSql(t.pana_cand_data)) <  dataFinish) || (new Date(u.ParseDataFromSql(t.cand_data)) >  dataStart) && (new Date(u.ParseDataFromSql(t.cand_data)) <  dataFinish))

   

       

        this.setState({dataStartWeek:dataStart,
            listTaskuriFiltered: taskuriFilter,
                    dataFinishWeek:dataFinish})


    }

    goNextWeek = () =>{

        let u = new Utils()
        let cloneTaskuri = [...this.state.listTaskuri]

        let dataStart = u.addDays(this.state.dataStartWeek, 6)
        let dataFinish = u.addDays(this.state.dataFinishWeek, 6)
        let taskuriFilter = cloneTaskuri.filter(t => (new Date(u.ParseDataFromSql(t.pana_cand_data)) >  dataStart) && (new Date(u.ParseDataFromSql(t.pana_cand_data)) <  dataFinish) || (new Date(u.ParseDataFromSql(t.cand_data)) >  dataStart) && (new Date(u.ParseDataFromSql(t.cand_data)) <  dataFinish) )



       

        this.setState({dataStartWeek:dataStart,
            listTaskuriFiltered: taskuriFilter,
                    dataFinishWeek:dataFinish})
    }


    goBack1Week = () =>{

        let u = new Utils()
        let cloneTaskuri = [...this.state.listTaskuri]
        let dataStart = u.addDays(this.state.dataStartWeek, -6)
        let dataFinish = u.addDays(this.state.dataFinishWeek, -6)

        let taskuriFilter = cloneTaskuri.filter(t => (new Date(u.ParseDataFromSql(t.pana_cand_data)) >  dataStart) && (new Date(u.ParseDataFromSql(t.pana_cand_data)) <  dataFinish) || (new Date(u.ParseDataFromSql(t.cand_data)) >  dataStart) && (new Date(u.ParseDataFromSql(t.cand_data)) <  dataFinish))


       

        this.setState({dataStartWeek:dataStart,
            listTaskuriFiltered: taskuriFilter,
                    dataFinishWeek:dataFinish})
    }


    filterByZi = (ev) => {

        let cloneTaskuri = [...this.state.listTaskuri]

        let u = new Utils()






        let taskuriFilter = cloneTaskuri.filter(t => new Date(u.ParseDataFromSql(t.pana_cand_data)).getFullYear() === this.state.nrYear)

        taskuriFilter = taskuriFilter.filter(t => (new Date(u.ParseDataFromSql(t.pana_cand_data)).getMonth() + 1) === this.state.luna)

        // console.warn('taskuriFilter :', taskuriFilter);

        taskuriFilter = taskuriFilter.filter(t => new Date(u.ParseDataFromSql(t.pana_cand_data)).getDate() === ev.target.value)

        // console.warn('ev.target.value day :', ev.target.value);

        this.setState({
            listTaskuriFiltered: taskuriFilter,
            day: ev.target.value,
        })
    }

    filterByLuna = (ev) => {


        let cloneTaskuri = [...this.state.listTaskuri]

        let u = new Utils()

        let day = new Date().getDate()


        // console.warn('day sssssss:', day);

        let taskuriFilter = cloneTaskuri.filter(t => new Date(u.ParseDataFromSql(t.pana_cand_data)).getFullYear() === this.state.nrYear)

        taskuriFilter = taskuriFilter.filter(t => (new Date(u.ParseDataFromSql(t.pana_cand_data)).getMonth() + 1) === ev.target.value)

        // console.log('ev.target.value :', ev.target.value);

        this.setState({
            listTaskuriFiltered: taskuriFilter,
            listDays: u.getZile(ev.target.value),
            luna: ev.target.value
        })
    }

    filterByYear = (ev) => {
        let cloneTaskuri = [...this.state.listTaskuri]

        let u = new Utils()


        let taskuriFilter = cloneTaskuri.filter(t => new Date(u.ParseDataFromSql(t.pana_cand_data)).getFullYear() === ev.target.value)

        // console.log('ev.target.value :', ev.target.value);

        this.setState({
            listTaskuriFiltered: taskuriFilter,
            nrYear: ev.target.value
        })
    }




    render() {
        return (
            <div>
                <AppBar
                    history={this.props.history}
                    title={this.dictionary.appBar.drawer.infoUser}
                    appBarButtons={this.buildAppBarButtons()}
                />

                <Grid container className="container" >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <div
                            onClick={() => { this.selectFile('fileavatar') }}
                            id='pm-user-avatar' style={{
                                width: 100,
                                height: 100,
                                backgroundImage: `url(${this.state.objUserData.poza ? (new Ws().adresaMedia + '/Angajati/' + this.state.objUserData.poza) : avatar})`,
                                backgroundRepeat: 'no-reapeat',
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                display: 'inline-block'
                            }}>
                            <input type='file'
                                id={`fileavatar`}
                                style={{ display: 'none' }}
                                accept='image/*'
                                onChange={() => { this.uploadPoza(`fileavatar`, this.state.objUserData.id) }} />
                        </div>
                        <h1 className='pm-title'>{this.state.objUserData.nume}</h1>
                        <Divider className='pm-divider' />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} xl={4} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="with-placeholder"
                            disabled={this.state.userAdmin}
                            label={this.dictionary.settings.nume}
                            margin="normal"
                            value={this.state.objUserData.nume || ''}
                            onChange={this.handleChange('nume')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} xl={4} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="password-input"
                            disabled={this.state.userAdmin}
                            label={this.dictionary.settings.email}
                            type="text"
                            margin="normal"
                            value={this.state.objUserData.email || ""}
                            onChange={this.handleChange('email')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} xl={4} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="password-input"
                            label={this.dictionary.settings.telefon}
                            type="number"
                            margin="normal"
                            value={this.state.objUserData.telefon || ""}
                            onChange={this.handleChange('telefon')}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="loginButton" >
                        <Button
                            variant="outlined"
                            className='pm-save-button'
                            color="primary"
                            onClick={this.updateUser}>
                            {this.dictionary.comune.save}
                        </Button>
                        {/* <Button 
                        style={{marginLeft:10}}
                            variant="outlined" 
                            className='pm-save-button' 
                            color="primary" 
                            onClick={()=>{this.props.history.push(`/userprojects/${this.state.objUserData.id}`)}}>
                            {this.dictionary.settings.veziProiecte}
                        </Button> */}


                    </Grid>

                </Grid>

                <Grid container className="container" >
                    <Divider className="pm-divider" />
                    <Grid className='pm-switch-container' item xs={12} sm={12} md={6} lg={6} xl={6} >
                        <Switch
                            className={this.state.objUserData.access_proiecte !== 1 ? '' : "pm-switch"}
                            disabled={this.state.userAdmin}
                            checked={this.state.objUserData.access_proiecte !== 1 ? false : true}
                            onChange={this.handleChecked('access_proiecte')}
                            value='companie'
                        />
                        <span className='pm-switch-label'>{this.dictionary.settings.accessProjects}</span>
                    </Grid>

                    <Grid className='pm-switch-container' item xs={12} sm={12} md={6} lg={6} xl={6} >
                        <Switch
                            className={this.state.objUserData.creaza_proiecte !== 1 ? '' : "pm-switch"}
                            disabled={this.state.userAdmin}
                            checked={this.state.objUserData.creaza_proiecte !== 1 ? false : true}
                            onChange={this.handleChecked('creaza_proiecte')}
                            value='companie'
                        />
                        <span className='pm-switch-label'>{this.dictionary.settings.createProjects}</span>
                    </Grid>

                    <Grid className='pm-switch-container' item xs={12} sm={12} md={6} lg={6} xl={6} >
                        <Switch
                            className={this.state.objUserData.modifica_angajati !== 1 ? '' : "pm-switch"}
                            disabled={this.state.userAdmin}
                            checked={this.state.objUserData.modifica_angajati !== 1 ? false : true}
                            onChange={this.handleChecked('modifica_angajati')}
                            value='companie'
                        />
                        <span className='pm-switch-label'>{this.dictionary.settings.modifyEmployees}</span>
                    </Grid>

                    <Grid className='pm-switch-container' item xs={12} sm={12} md={6} lg={6} xl={6} >
                        <Switch
                            className={this.state.objUserData.is_admin !== 1 ? '' : "pm-switch"}
                            disabled={this.state.userAdmin}
                            checked={this.state.objUserData.is_admin !== 1 ? false : true}
                            onChange={this.handleChecked('is_admin')}
                            value='companie'
                        />
                        <span className='pm-switch-label'>{this.dictionary.settings.isAdmin}</span>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="loginButton" >
                        <Button variant="outlined"
                            className='pm-delete-button'
                            disabled={this.state.userAdmin}
                            color="primary"
                            onClick={() => { this.setState({ isOpenAlert: true }) }}>
                            {this.dictionary.settings.deactivateAccount}
                        </Button>


                    </Grid>


                </Grid>


                <Divider className="pm-divider" />



                <div style={{ position: 'relative', marginTop: 50 }}>

                    {/* {this.state.proiecte.length > 0 && 
<div style={{height:'40vh', overflow:'scroll', width:'95%', margin:'auto'}}>
<CardsDynamic elemente={this.state.proiecte}
          onlyColumns = {{title:'titlu', content:'descriere' }}
          onElementClick ={this.onProiectSelectat}
          dictionary={this.dictionary}
          />



</div>  } */}



                    <div style={{ width: '100%', overflow: 'hidden', minHeight: '85vh', height: '100%', position: 'relative' }}>

                        <h3 style={{ width: 'fit-content', margin: 'auto', borderBottom: '1px solid gray' }} className='pm-title'>{this.dataAzi()}</h3>
                        <div style={{ height: '100%', position: 'absolute', left: 0, right: 0, margin: 'auto', width: 1, backgroundColor: '#e0e0e0' }}></div>
                        {/* <div  style={{ marginTop:20, overflowX:'scroll', overflowY:'hidden', textAlign:'left', height:'100%', display:'flex', position:'relative'}}> */}



                        {/* <GanttProiecteWeekView
    dictionary={this.dictionary}
    objPerioadaGantt={this.state.objPerioadaGantt}
    listEtape={this.state.listEtape}
    listProiecte={this.state.proiecte}
    history={this.props.history}
    /> */}



                        <GanttProiecteMonthView
                            objPerioadaGantt={this.state.objPerioadaGantt}
                            listEtape={this.state.listEtape}
                            listProiecte={this.state.proiecte}
                            history={this.props.history}
                            dictionary={this.dictionary}
                            idProiect={[{ id: 'infoUser' }]}
                            idUser={this.props.match.params.iduser}

                        />

                        <Divider className='pm-divider' />

                        <div className='container'>

                            <FormControl className='inputFocus' style={{ width: '90%', marginTop: 20, marginBottom: 20 }}>
                                <InputLabel htmlFor="resursa">Filtreaza in functie de</InputLabel>
                                <Select

                                    value={this.state.tipFilter || ""}
                                    onChange={this.changeFilter}

                                    input={<Input id="resursa" />}>


                                    {this.state.tipuriFilter.map((s, idx) => {
                                        return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                    })
                                    }
                                </Select>
                            </FormControl>

                            <Grid style={{ marginBottom: 20, justifyContent: 'center' }} className='container' container>




                                <Grid style={{ display: this.state.displayAn === true ? 'block' : 'none' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                    <FormControl className='inputFocus' style={{ width: '90%', marginTop: 20 }}>
                                        <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.selecteazaAnul}</InputLabel>
                                        <Select

                                            value={this.state.nrYear || ""}
                                            onChange={this.filterByYear}

                                            input={<Input id="resursa" />}>


                                            {this.state.listYears.map((s, idx) => {
                                                return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                            })
                                            }
                                        </Select>
                                    </FormControl>

                                </Grid>
                                <Grid style={{ display: this.state.displayLuna === true ? 'block' : 'none' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                    <FormControl className='inputFocus' style={{ width: '90%', marginTop: 20 }}>
                                        <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.selecteazaLuna}</InputLabel>
                                        <Select

                                            value={this.state.luna || ""}
                                            onChange={this.filterByLuna}

                                            input={<Input id="resursa" />}>


                                            {this.state.listMonths.map((s, idx) => {
                                                return <MenuItem value={s.id} key={idx}  > {s.luna}</MenuItem>

                                            })
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid style={{ display: this.state.displayZi === true ? 'block' : 'none' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                    <FormControl className='inputFocus' style={{ width: '90%', marginTop: 20 }}>
                                        <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.selecteazaZi}</InputLabel>
                                        <Select

                                            value={this.state.day || ""}
                                            onChange={this.filterByZi}

                                            input={<Input id="resursa" />}>


                                            {this.state.listDays.map((s, idx) => {
                                                return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                            })
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid style={{ display: this.state.displaySapt=== true ? 'block' : 'none' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                        <p
                                        style={{color:'white',
                                                fontSize:20,
                                                padding:10,
                                                backgroundColor:'#8282de',
                                                borderRadius:10}}
                                        ><i style={{cursor:'pointer'}} onClick={this.goBack1Week} className='material-icons'>keyboard_arrow_left</i> 
                                                <span style={{verticalAlign:'super'}}>{new Utils().dataPrescurtataRomanaNoYear(this.state.dataStartWeek)}-{new Utils().dataPrescurtataRomanaNoYear(this.state.dataFinishWeek)}</span>
                                                            <i style={{cursor:'pointer'}} onClick={this.goNextWeek} className='material-icons'>keyboard_arrow_right</i></p>
                                </Grid>
                            </Grid>

                            <TaskuriList
                                listTaskuri={this.state.listTaskuriFiltered}
                                listSubtaskuri={this.state.listSubTaskuri}
                                listEtape={this.state.etape}
                                dict={this.dictionary}
                                onTaskClick={this.goToTaskProj}
                                etapaInfo={this.state.objEtapaSelectata}
                            />

                        </div>

                        {/* </div> */}
                    </div>
                </div>

                <AlertDialog
                    open={this.state.isOpenAlert}
                    dialogClose={() => { this.setState({ isOpenAlert: false }) }}
                    title={this.dictionary.settings.alertDeactivate}
                    limba={this.dictionary}
                    yesFunction={this.dezactiveazaCont}
                />

            </div>
        );
    }
}